import { Container, Row, Col, Card } from "react-bootstrap"

const AboutPage = () => {
  return (
    <Container className="py-5">
      <Row>
        <Col>
          <Card className="shadow">
            <Card.Body className="p-5">
              <div className="text-center mb-5">
                <h1 className="display-4 fw-bold text-success mb-3">🌱 About AgroPlanner</h1>
                <p className="lead text-muted">Smart Crop Suitability & Planting Date Advisor</p>
              </div>

              <Row>
                <Col md={6}>
                  <h3 className="fw-bold mb-3">🎯 Our Mission</h3>
                  <p>
                    AgroPlanner helps farmers and agricultural professionals make informed decisions about crop
                    selection and planting schedules based on location-specific weather data and scientific analysis.
                  </p>

                  <h3 className="fw-bold mb-3 mt-4">🌟 Key Features</h3>
                  <ul>
                    <li>Interactive map-based location selection</li>
                    <li>Multi-year weather data analysis</li>
                    <li>Advanced crop suitability algorithm</li>
                    <li>Visual planting calendars</li>
                    <li>Downloadable PDF reports</li>
                    <li>Admin panel for crop database management</li>
                  </ul>
                </Col>

                <Col md={6}>
                  <h3 className="fw-bold mb-3">🔬 How It Works</h3>
                  <div className="mb-3">
                    <h6 className="fw-bold">1. Location Selection</h6>
                    <p className="small text-muted">Click anywhere on the map to select your farming location</p>
                  </div>

                  <div className="mb-3">
                    <h6 className="fw-bold">2. Weather Analysis</h6>
                    <p className="small text-muted">System retrieves historical weather data for your location</p>
                  </div>

                  <div className="mb-3">
                    <h6 className="fw-bold">3. Crop Matching</h6>
                    <p className="small text-muted">Algorithm matches crops to your local climate conditions</p>
                  </div>

                  <div className="mb-3">
                    <h6 className="fw-bold">4. Results & Reports</h6>
                    <p className="small text-muted">Get detailed analysis with optimal planting windows</p>
                  </div>
                </Col>
              </Row>

              <hr className="my-5" />

              <Row>
                <Col md={4}>
                  <div className="text-center">
                    <h4 className="fw-bold text-primary">🌍 Global Coverage</h4>
                    <p className="text-muted">Works worldwide with comprehensive weather data</p>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="text-center">
                    <h4 className="fw-bold text-success">📊 Data-Driven</h4>
                    <p className="text-muted">Based on scientific analysis and historical weather patterns</p>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="text-center">
                    <h4 className="fw-bold text-info">🆓 Free to Use</h4>
                    <p className="text-muted">No registration required for basic crop analysis</p>
                  </div>
                </Col>
              </Row>

              <div className="text-center mt-5">
                <p className="text-muted">Built with ❤️ for farmers and agricultural professionals worldwide</p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}

export default AboutPage
